// extracted by mini-css-extract-plugin
export default {"card":"ShareCta_card__5nxwF","btnWrapper":"ShareCta_btnWrapper__mKucz"};